import Image from 'next/image';
import { cn } from '@/helpers/cn';

interface ContentCardBadgesProps {
    isRtl?: boolean;
    isExclusive?: boolean;
    isComingSoon?: boolean;
    size?: string | null;
}

const ContentCardBadges = ({
    isRtl,
    isExclusive,
    isComingSoon,
    size = null
}: ContentCardBadgesProps) => (
    <div className={cn('content-card-badges-container', { rtl: isRtl }, size ? 'is-large' : '')}>
        {isExclusive && (
            <div className={`exclusive-label relative ${size}`}>
                <Image src="/svg/exclusiveBadge.svg" alt="exclusive-badge" fill={true} />
            </div>
        )}
        {isComingSoon && (
            <div className={`coming-soon-label relative ${size}`}>
                <Image src="/svg/comingSoonBadge.svg" alt="exclusive-badge" fill={true} />
            </div>
        )}
    </div>
);

export default ContentCardBadges;
